import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { announceSyncStatus, dismissSyncProblems, syncNow } from '../services/syncEngine';

const INITIAL = { syncing: false, error: null, pending: 0, problems: [], lastSyncedAt: null };

const SyncContext = createContext({ ...INITIAL, syncNow: () => {}, dismiss: () => {} });

/**
 * The state of the outbox for the signed-in user: how many changes are
 * waiting, whether a sync is running, when the last one finished, and any
 * changes the server didn't apply. Fed by the sync engine's 'sync:status'
 * events.
 */
export const SyncProvider = ({ children }) => {
  const [status, setStatus] = useState(INITIAL);

  useEffect(() => {
    const onStatus = (event) => setStatus({ ...INITIAL, ...event.detail });
    window.addEventListener('sync:status', onStatus);
    announceSyncStatus();
    return () => window.removeEventListener('sync:status', onStatus);
  }, []);

  const dismiss = useCallback((ids) => dismissSyncProblems(ids), []);
  const value = useMemo(() => ({ ...status, syncNow, dismiss }), [status, dismiss]);
  return <SyncContext.Provider value={value}>{children}</SyncContext.Provider>;
};

export const useSync = () => useContext(SyncContext);
